module.exports = __webpack_public_path__ + "img/CUFFLABI.63100aef.jpg";